import * as React from 'react'
import './Experience.css'

// Declare the form in which props must be passed into the ExperienceCard component
interface ExperienceProps {
  location: string
  jobTitle: string
  jobInfo: string
}

const ExperienceCard: React.ElementType = (props: ExperienceProps) => {
  // Destruct our props out
  const { location, jobTitle, jobInfo } = props

  return (
      <>
        <div className="card">
          <div className="card-header">
            <h5 className="text-left ml-2">{location}<span className="job-title">{jobTitle}</span></h5>
          </div>
          <div className="card-content m-3">
            <p>{jobInfo}</p>
          </div>
        </div>
      </>
  )
}

export default ExperienceCard
